<template>
  <div
    id="winemaker-content"
    class="d-lg-inline-block position-relative w-100"
    @mouseenter="toggleAdminTools"
    @mouseleave="toggleAdminTools"
  >
    <div class="pa-3 p-lg-0">
      <SingleTool
        v-if="customerIsAdmin && toolType"
        class="mr-2"
        :display="displayTool"
        :type="toolType"
        :id="product.manufacturer_id"
      />
      <WineMakerDescription :manufacturer-id="product.manufacturer_id" />
      <VContainer>
        <WideProductTileList
          :products-to-fetch="productsToFetch?.slice(0, productsLimit)"
          item-list-id="winemaker_wines"
          data-elbcontext="shopping:discover;wide_product_tile:additional_products_of_winemaker"
        />
      </VContainer>
      <div class="text-center mb-3">
        <VBtnSecondary
          class="mt-3"
          :href="product.manufacturer_link"
          :text="translate('pdp_button_to_winery')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WideProductTileList from '@/components/pdp/atoms/WideProductTileList.vue'
import WineMakerDescription from '@/components/pdp/atoms/WineMakerDescription.vue'
import { useCustomerStore } from '@/stores/customer'
import { usePdpStore } from '@/stores/pdp'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'

const PRODUCTS_LIMIT = 5

const SingleTool = defineAsyncComponent(
  () => import('@/components/basic/molecules/SingleTool.vue')
)

export default {
  name: 'WineMaker',
  components: {
    WideProductTileList,
    SingleTool,
    WineMakerDescription
  },
  data() {
    return {
      toolType: null,
      displayTool: false,
      WMKey: null,
      productsLimit: PRODUCTS_LIMIT
    }
  },
  computed: {
    ...mapState(useCustomerStore, ['customerIsAdmin']),
    ...mapState(usePdpStore, { product: 'getApiProduct' }),
    productsToFetch() {
      return this.product.manufacturer_related_products
    }
  },
  methods: {
    toggleAdminTools() {
      this.displayTool = !this.displayTool
    }
  },
  async created() {
    const {
      TYPES: { EDIT_MANUFACTURER }
    } = await import('@/constants/AdminTool')
    this.toolType = EDIT_MANUFACTURER
  }
}
</script>

<style scoped>
.admin-tools {
  top: -2rem;
  right: 0;
}
</style>
